export default __webpack_public_path__ + "static/828_2-14151adfa8e7d2f5369f006de72bb8e3.png";